/**
 * Extract value from unary matcher data.
 */
export function numericTransform(unaryNumericObject) {
    return unaryNumericObject.value;
}
